import { PosAbsolute, PosRelative } from '@layout/BuildingBlocks'
import React from 'react'

export const DiscoIcon = ({
  size = 32,
  width,
  iconColor = '#4C4D4C',
  backgroundColor = '#62A9D1',
  strokeWidth,
  shadow = true,
}) => {
  return (
    <PosRelative width={width || size} height="100%">
      <PosAbsolute>
        <svg
          width={width || size}
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="19.5" cy="17.5" r="12.5" fill={backgroundColor} />
        </svg>
      </PosAbsolute>
      <PosAbsolute>
        <svg
          width={width || size}
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ filter: shadow && 'drop-shadow(0 5px 3px #bfbfbf)' }}
        >
          <path
            d="M28.9749 14.0039C28.8517 10.7788 27.4834 7.72675 25.1574 5.48854C22.8313 3.25034 19.7284 2 16.4999 2C13.2714 2 10.1685 3.25034 7.84244 5.48854C5.5164 7.72675 4.14815 10.7788 4.0249 14.0039H4V15.0036H4.0254C4.15227 18.2227 5.51895 21.2682 7.83974 23.5034C10.1605 25.7385 13.2557 26.9903 16.4783 26.9971C16.4856 26.9971 16.4929 27 16.5005 27C16.5081 27 16.5151 26.9971 16.5225 26.9971C19.745 26.9903 22.8402 25.7385 25.1609 23.5033C27.4816 21.2681 28.8482 18.2227 28.9749 15.0036H29V14.0039H28.9749ZM26.58 9.00541H20.5322C20.2673 6.92491 19.5347 4.93135 18.3894 3.17417C20.1075 3.46184 21.7377 4.13629 23.1567 5.14652C24.5756 6.15676 25.7463 7.47631 26.58 9.00541V9.00541ZM13.01 14.0039C13.027 12.6657 13.1303 11.33 13.3191 10.0051H19.6814C19.8706 11.3303 19.9741 12.6664 19.9914 14.0049L13.01 14.0039ZM19.9917 15.0036C19.9747 16.3418 19.8713 17.6775 19.6824 19.0024H13.3189C13.1301 17.6775 13.0269 16.3418 13.01 15.0036H19.9917ZM16.5 3.00872C17.5044 3.00872 18.823 5.24095 19.5176 9.00591H13.4827C14.1773 5.24095 15.4956 3.00872 16.5 3.00872ZM14.6108 3.17467C13.4658 4.93177 12.7334 6.92514 12.4685 9.00541H6.42C7.25387 7.47632 8.42463 6.15681 9.84373 5.14666C11.2628 4.13652 12.8931 3.46218 14.6113 3.17467H14.6108ZM6 9.85766V10.0051H12.32C12.1353 11.3304 12.033 12.6659 12.0137 14.0039H5.023C5.08558 12.5728 5.41701 11.1662 6 9.85766V9.85766ZM6 19.1484C5.4172 17.8403 5.08577 16.4342 5.023 15.0036H12.013C12.0328 16.3416 12.1353 17.6771 12.32 19.0024H6V19.1484ZM6.4212 20.0021H12.468C12.733 22.0817 13.4646 24.0745 14.608 25.8318C12.8907 25.5438 11.2614 24.8693 9.84316 23.8593C8.42489 22.8494 7.25477 21.5304 6.4212 20.0021V20.0021ZM16.5 26.0013C15.4949 26.0013 14.176 23.7686 13.4817 20.0016H19.5181C18.824 23.7686 17.5049 26.0013 16.5 26.0013ZM18.3918 25.8314C19.5357 24.0743 20.2675 22.0816 20.5327 20.0021H26.5791C25.7455 21.5304 24.5754 22.8493 23.1571 23.8592C21.7389 24.869 20.1095 25.5434 18.3923 25.8315L18.3918 25.8314ZM27 19.1484V19.0024H20.68C20.8646 17.6771 20.9671 16.3416 20.9869 15.0036H27.9769C27.9138 16.4342 27.5825 17.8401 27 19.1484V19.1484ZM20.9871 14.0039C20.9675 12.6659 20.8649 11.3304 20.68 10.0051H27V9.85816C27.5829 11.1666 27.9146 12.5729 27.9776 14.0039H20.9871Z"
            fill={iconColor}
            stroke={iconColor}
            strokeWidth={strokeWidth}
          />
        </svg>
      </PosAbsolute>
    </PosRelative>
  )
}
